<template>
  <h1 class="a11y-blind">메인 페이지</h1>
  
  <section class="main-visual-wrap">
    <!-- 메인 배너 영역 -->
    <div class="banner-box">
      <div class="banner-area">
        <div class="main-slide-banner">
          <swiper :modules="mainSlideBannerModules" @swiper="onMainVisualSwiper" @slideChange="onSlideMainVisualChange" :slides-per-view="1" :space-between="20" :direction="'horizontal'" :loop="false" :autoplay="{delay: 10000, disableOnInteraction: false}" :navigation="{ nextEl: '.visual-next-btn', prevEl: '.visual-prev-btn'}" :pagination="paginationOptions" class="main-event-list">
            <swiper-slide v-for="(bnnr, index) in mainBannerList" :key="index" class="main-event-item">
              <NuxtLink to="" class="main-event-link">
                <img :src="bnnr.src" @:click="moveBannerPage(bnnr.bnnrSeq, bnnr.nwinMvYn, bnnr.link)">
              </NuxtLink>
            </swiper-slide>
          </swiper>
          <!-- navigation Buttons -->
          <div class="navi-box">
            <div class="pagination">
              <button type="button" class="swiper-button-prev swiper-button visual-prev-btn" aria-label="이전"></button>
              <div ref="paginationEl" class="swiper-pagination number"></div>
              <button type="button" class="swiper-button-next swiper-button visual-next-btn" aria-label="다음"></button>
            </div>
            <div class="swiper-controls">
              <button v-if="isPlaying" type="button" class="play-btn" @click="toggleAutoplay" aria-label="재생"></button>
              <button v-else type="button" class="stop-btn" @click="toggleAutoplay" aria-label="정지"></button>
            </div>
          </div>
        </div>        
      </div>
      <div class="bg-box">
        <div class="bg-area"></div>
      </div>
    </div>
    <!-- 바로가기 카테고리 영역 -->
    <div class="quick-category-box">
      <h2 class="quick-cate-title">카테고리 바로가기</h2>
      <ul class="cate-ul">
        <li class="cate-item" v-for="(item, index) in quickCateList" :key="index">
          <NuxtLink :to="item.link" class="cate-link" @click.prevent="getDepth(item)">
            <img :src="item.src" width="40" height="40" alt="">
            {{ item.cateName }}
          </NuxtLink>
        </li>
      </ul>
    </div>
  </section>

  <!-- 지금 가장 많이 찾는 인기 상품 s -->
  <section class="section-box now-product inner">
    <h2 class="fs30 font-bold">지금 가장 많이 찾는 인기 상품</h2>
    <!-- tab title s -->
    <div class="tab-box mt40">
      <div class="tab-area v3">
        <ul class="tab-list">
          <li v-for="(item, idx) in popularCate.v3.items" 
            :key="idx"
            class="tab-item" 
            :class="{ active: popularCate.v3.activeIndex === idx }">
            <button class="tab-btn" @click="handleTabClick('v3', idx, item.hcRcmmGdsClsCd)">
              <span class="tab-text">{{ item.text }}</span>
            </button>
          </li>
        </ul>
      </div>
      <NuxtLink :to="{path: '/pc/product/search', query: { searchMassCd : 'best100', t:Date.now()} }" class="link-btn gray100">더보기</NuxtLink>
    </div>
    <!-- tab title e -->
    
    <!-- tab pannel s -->
    <div class="tab-wrap">
      <div class="now-popular-area">
        <button type="button" class="swiper-button-prev swiper-button circle-button now-prev-btn" aria-label="이전"></button>
        <swiper :modules="nowPopularSlideModules" @swiper="onNowPopularSwiper" @slideChange="onNowPopularSlideChange" :slides-per-view="2" :grid="{ rows: 2, fill: 'row' }" :slides-per-group="2" :space-between="20" :direction="'horizontal'" :loop="false" :autoplay="{delay: 3000, disableOnInteraction: false}" :navigation="{ nextEl: '.now-next-btn', prevEl: '.now-prev-btn'}" :observer="true" :observeParents="true" class="now-popular-pro-list">
          <swiper-slide v-for="nowItem in nowPopularProList" :key="nowItem.id" class="pro-li">
            <HconProductItem @open-popup="showAddedGoodsImportPopup" viewType="row" :useControl="true" :hideInfo="false" :item="nowItem"/>
          </swiper-slide>
        </swiper>
        <button type="button" class="swiper-button-next swiper-button circle-button now-next-btn" aria-label="다음"></button>
      </div>
    </div>
    <!-- tab pannel e -->
  </section>
  <!-- 지금 가장 많이 찾는 인기 상품 e -->

  <!-- 대량구매 전용 인기 상품 s -->
  <section class="section-box many-product inner">
    <div class="title-box">
      <h2 class="fs30 font-bold">대량구매 전용 인기 상품</h2>
      <NuxtLink :to="{path: '/pc/product/search', query: {  searchMassCd : 'mass', t:Date.now()} }" class="link-btn gray100">더보기</NuxtLink>
    </div>
    <div class="many-popular-box">
      <button type="button" class="swiper-button-prev swiper-button circle-button many-prev-btn" aria-label="이전"></button>
      <div class="banner-area">
        <NuxtLink to="" alt="Hcon 대량구매 전용 특별 할인 혜택을 확인하세요!">
          <img :src="middleBnnrImgPath" @:click="moveBannerPage(middleBnnrSeq, middleBnnrNwinMvYn, middleBnnrShctUrl)" width="240" height="833" alt="Hcon 대량구매 전용 특별 할인 혜택을 확인하세요!">
        </NuxtLink>
      </div>
      <div class="many-product-area">
        <swiper :modules="manyPopularSlideModules" @swiper="onManyPopularSwiper" @slideChange="onManyPopularSlideChange" :slides-per-view="4" :grid="{ rows: 2, fill: 'row' }" :slides-per-group="4" :space-between="20" :direction="'horizontal'" :loop="false" :autoplay="{delay: 3000, disableOnInteraction: false}" :navigation="{ nextEl: '.many-next-btn', prevEl: '.many-prev-btn'}" :observer="true" :observeParents="true" class="many-popular-pro-list">
          <swiper-slide v-for="manyItem in manyPopularProList" :key="manyItem.id" class="pro-li">
            <HconProductItem @open-popup="showAddedGoodsImportPopup" viewType="column" :useControl="true" :hideInfo="false" :item="manyItem"/>
          </swiper-slide>
        </swiper>
      </div>
      <button type="button" class="swiper-button-next swiper-button circle-button many-next-btn" aria-label="다음"></button>
    </div>
  </section>
  <!-- 대량구매 전용 인기 상품 e -->

  <!-- 텍스트형 안내 링크 및 공지사항 s -->
  <section class="section-box noti inner">
    <div class="info-area">
      <ul class="info-list col3">
        <li class="join">
          <NuxtLink :to="'/pc/etc/homepage-use-guide'" class="info-link">
            <h3 class="title">Hcon 이용안내</h3>
            <p class="desc">Hcon 가입부터 구매·결제까지<br />서비스 이용에 필요한<br />다양한 정보를 확인하실 수<br />있습니다.</p>
          </NuxtLink>
        </li>
        <li class="qna">
          <NuxtLink to="/pc/inquiry/list" class="info-link">
            <h3 class="title">1:1 문의하기</h3>
            <p class="desc">이용 중 불편 사항이나<br />문의가 있으시면 언제든<br />1:1 상담으로<br />도움 받으실 수 있습니다.</p>
          </NuxtLink>
        </li>
        <li class="guide">
          <NuxtLink to="/pc/mypage/hcash/charge" class="info-link">
            <h3 class="title">캐쉬 충전·사용 안내</h3>
            <p class="desc">카드결제와 계좌이체는 물론,<br />캐쉬 충전을 통해<br />원하는 상품을 간편하게<br />결제할 수 있습니다.</p>
          </NuxtLink>
        </li>
      </ul>
    </div>
    <div class="noti-area">
      <h3 class="title">공지사항</h3>
      <ul class="noti-list">
        <li v-for="(data, index) in noticeList" :key="index" class="noti-li">
          <NuxtLink :to="String(data.link)" class="noti-link">
            <span class="text ellips">{{ data.title }}</span>
            <span class="reg-data" style="white-space: nowrap;">{{ HconCommonUtils.format.date(data.regDate) }}</span>
          </NuxtLink>
        </li>
      </ul>
      <NuxtLink to="/pc/notice/list" class="link-btn gray100">더보기</NuxtLink>
    </div>
  </section>
  <!-- 텍스트형 안내 링크 및 공지사항 e -->
  <!-- 담긴상품불러오기 팝업 -->
  <HconAddedGoodsImport :flag=false ref="popupAddedGoodsImportRef" />
</template>

<script setup lang="ts">
import HconProductItem, { type ProductItemType } from '@/components/com/HconComPCProductItem.vue'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Grid, Autoplay, Navigation, Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper'
import 'swiper/css';
import 'swiper/css/grid';
import type { Notice } from '@/types/notice/backend-dto-types'
import type { DisplayMainInfo } from '@/types/display/backend-dto-types';
import type { CodeDto } from '~/types/common/backend-dto-types';
import HconAddedGoodsImport from '@/components/popup/HconAddedGoodsImport.vue'

const fetchBuilder  = useHconFetchBuilder();
const router  = useRouter();
const searchMassCd = ref("")
// 메인페이지 설정
definePageMeta({
  "require-auth" : false,
  isMain : true
});

// 비밀번호만료여부(만료 => 'PASS')
const isExpiredPswd = useHconAuthInfo().getIfPossible()?.userContext.isExpiredPswd

onMounted(() => {
  // // 비밀번호만료일이 지난 경우 비밀번호변경캠페인 페이지로 이동
  // if(isLoggedIn.value === true && isExpiredPswd === 'PASS') {
  //   navigateTo({path: '/pc/common/password'});
  // }
})

// 전역 팝업 설정(로그인여부)
const {showAlert, isLoggedIn} = usePopup()

// 슬라이더 현재 index
const activeIndex = ref<number>(0)

// 메인 슬라이드 현재 배너에서 다음 배너로 체인지 될 때 index값으로 변경하여 슬라이드 되게 함
const onSlideMainVisualChange = (swiper: any) => {
  activeIndex.value = swiper.realIndex
}

// 메인 슬라이드 배너 모듈
const mainSlideBannerModules = [Autoplay, Navigation, Pagination]

// 메인 배너 데이터
const mainBannerList = ref<MainBnnrData[]>();

// 중간 배너 (대량구매 전용 인기 상품 아래에 나오는 세로형 배너)
const middleBnnrImgPath = ref("");
const middleBnnrShctUrl = ref("");
const middleBnnrNwinMvYn = ref("");
const middleBnnrSeq = ref(0);

// 이전 슬라이드
const swiperRef = ref<SwiperType | null>(null)
const isPlaying = ref(true)

const onMainVisualSwiper = (swiper: SwiperType) => {
  swiperRef.value = swiper
}

// 메인 슬라이드 배너 정지/재생 버튼
const toggleAutoplay = () => {
  if (!swiperRef.value) return

  if (isPlaying.value) {
    swiperRef.value.autoplay.stop()
  } else {
    swiperRef.value.autoplay.start()
  }
  isPlaying.value = !isPlaying.value //상태반전
}

// pagnation
const paginationEl = ref<HTMLElement | null>(null)
const paginationOptions = computed(() => ({
  el: paginationEl.value,
  type: 'fraction' as const,
  renderFraction: (currentClass: string, totalCalss: string):string => {
    return `
      <span class="custom-pagination">
        <span class="${currentClass}">${currentClass}</span><span class="divider">/</span><span class="${totalCalss}">${totalCalss}</span>
      </span>
    `
  }
}))
const userGrade = useHconAuthInfo().getIfPossible()?.userContext.userGrade;

type UserGrade = 'friends' | 'gold' | 'platinum' | 'black';
const myGrade = () => {
  if(!isLoggedIn.value) return 'platinum'

  if(userGrade == '1000') return 'friends'
  if(userGrade == '1010') return 'gold'
  if(userGrade == '1020') return 'platinum'
  if(userGrade == '9999') return 'black'

  return 'friends'
} 
// 카테고리 바로가기 타입 정의
interface QuickCateData {
  cateName: string
  cateCd?: string
  src : string
  link: string
}
// 메인 배너  타입 정의
interface MainBnnrData {
  src: string
  link: string
  nwinMvYn: string
  bnnrSeq: number
}

// const displayMainInfo = ref<DisplayMainInfo>();

// 바로가기 > 베스트100 고정
import cateImg01 from '@/assets/images/pc/main-hcon/cate1.png';
// 카테고리 바로가기 데이터
const quickCateList = ref<QuickCateData[]>();

const getDisplayMainInfo = async () => {
  fetchBuilder.get<AjaxResult<DisplayMainInfo>>('/api/v1/product/display/main')
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert(result.resultMessage);
      } else {
        // 메인 배너 세팅
        mainBannerList.value = result.data.displayBnnrList.filter((bnnr) => bnnr.hcBnnrTypCd == '1001').map((bnnr) => {
          return {
            src: cu.getFileFullUrl(bnnr.bnnrImgPath),
            link: bnnr.bnnrShctUrl,
            nwinMvYn: bnnr.nwinMvYn,
            bnnrSeq: bnnr.bnnrSeq
          }
        })

        // 중간 배너 세팅
        if(result.data.displayBnnrList.length > 0) {
          middleBnnrImgPath.value = cu.getFileFullUrl(result.data.displayBnnrList.filter((bnnr) => bnnr.hcBnnrTypCd == '1003')[0]?.bnnrImgPath);
          middleBnnrShctUrl.value = result.data.displayBnnrList.filter((bnnr) => bnnr.hcBnnrTypCd == '1003')[0]?.bnnrShctUrl;
          middleBnnrNwinMvYn.value = result.data.displayBnnrList.filter((bnnr) => bnnr.hcBnnrTypCd == '1003')[0]?.nwinMvYn;
          middleBnnrSeq.value = result.data.displayBnnrList.filter((bnnr) => bnnr.hcBnnrTypCd == '1003')[0]?.bnnrSeq;
        }

        // 바로가기 카테고리 세팅
        quickCateList.value = [
          { cateName: '베스트 100', src: cateImg01, link: '/pc/product/search?searchMassCd=best100&t='+Date.now() }, // 고정 노출 항목
          ...result.data.shctCtgrList.map(ctgr => {
            return {
              cateName: ctgr.shctCtgrNm,
              cateCd: ctgr.shctCtgrCd,
              src: cu.getFileFullUrl(ctgr.shctCtgrIconImgPath),
              link: '/pc/product/search?searchHighCategory=' + ctgr.shctCtgrCd + '&t=' + Date.now()
            }
          })
        ]
      }
  });
}

// 배너 클릭 시 클릭횟수 업데이트 및 화면 제어 (새창이동 또는 화면 전환)
const moveBannerPage = async (bnnrSeq: number, nwinMvYn: string, link: string) => {
  const res = await fetchBuilder
  .put<AjaxResult<void>>(`/api/v1/product/display/banner-click-count/${bnnrSeq}`)
  .build()
  .execute()
  .then(async (result) => {
    if(result.resultCode != '200') {
      showAlert(result.resultMessage);
    } else {
      if (nwinMvYn === 'Y') {
        // 새 창으로 이동
        window.open(link, '_blank');
      } else {
        window.location.href = link;
      }
    }
  })
}


//탭 유형 
type TabVersion = 'v3';
// 탭 클릭 핸들러
const handleTabClick =  (version: TabVersion, index: number, hcRcmmGdsClsCd: string) => {
  popularCate.value[version].activeIndex = index;
  searchMassCd.value = hcRcmmGdsClsCd
  getRecommandProductList(hcRcmmGdsClsCd); 
}

// 가장 많이 찾는 인기상품 슬라이드
const onNowPopularSlideChange = (swiper: any) => {
  activeIndex.value = swiper.realIndex
}

// swiper modules
const nowPopularSlideModules = [Grid, Navigation, Pagination]

// 이전 슬라이드
const swiperNowRef = ref<SwiperType | null>(null)
const onNowPopularSwiper = (swiper: SwiperType) => {
  swiperNowRef.value = swiper
}

// 지금 인기 상품 데이터
const nowPopularProList = ref<ProductItemType[]>([]);


// 대량구매 전용 인기 상품 슬라이드
const onManyPopularSlideChange = (swiper: any) => {
  activeIndex.value = swiper.realIndex
}

// swiper modules
const manyPopularSlideModules = [Grid, Navigation, Pagination]

// 이전 슬라이드
const swiperManyRef = ref<SwiperType | null>(null)
const onManyPopularSwiper = (swiper: SwiperType) => {
  swiperManyRef.value = swiper
}

// 대량 인기 상품 데이터
const manyPopularProList = ref<ProductItemType[]>([]);

// 공지사항 타입
interface NoticeData {
  ntcId: number,
  cate: string,
  title: string,
  link: string,
  regDate: string
}
const ntcList = ref<Notice[]>([]);
const searchParams = computed(() => {
  return {
    pageNum: 1,
    pageSize: 5
  };
});

const getNtcList = async () => {
  //ntcList.value = []; // No 계산 초기화
  fetchBuilder.get<TableDataInfo<Notice>>('/api/v1/notice/main/list')
    .query(searchParams.value)
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert(result.resultMessage);
        ntcList.value = [];
      } else {
        // ref 형식 변수에 값 즉시 세팅
        ntcList.value = result.data || [];
      }
  });
}

const noticeList = computed<NoticeData[]>(() => {
  //console.log("ntcList.value", ntcList.value);
  return ntcList.value.map((item) => {
    return {
      ntcId: item.ntcId,
      cate: item.hcNtcTypCd,
      title: item.ntcTitle,
      link: `/pc/notice/detail/${item.ntcId}`,
      regDate: item.ntcRegDt
    };
  });
});

interface ProductItemBadge {
  key: string
  text: string
}

const getRecommandProductList = async (key : string) => {
  const tmpProductList = ref<ProductItemType[]>([]);
  fetchBuilder.get<AjaxResult<any>>('/api/v1/product/search/recommand')
    .query({searchMassCd: key})
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if (key == '2002') {
        manyPopularProList.value = [];
      } else {
        nowPopularProList.value = [];
      }

      result.data.forEach((item: any) => {
            const badgeListTmp = ref<ProductItemBadge[]>([])

            if(item.mssBuyGdsYn == "Y") {
              badgeListTmp.value.push({key: 'bulk', text: '대량구매 ' + item.buyPossMinQty.toLocaleString() + '개'})
            }

            if(item.prmGdsYn == "Y") {
              badgeListTmp.value.push({key: 'event', text: 'EVENT'})
            }
            
            if(item.rank != null && item.rank != '' && Number(item.rank) != 0) {
              badgeListTmp.value.push({key: 'hot', text: 'HOT'})
            }

            if(item.newDspGdsYn == "Y") {
              badgeListTmp.value.push({key: 'new', text: 'NEW'})
            }

            const hcSellStCdTmp = item.hcDspStCd=='2003'?'exhDiscont':item.hcDspStCd=='2001'?'exhBefore':'';

            tmpProductList.value.push({
            isCashable: item.cshabGdsYn=='Y'?true:false,
            hcBrndCd: item.hcBrndCd,
            hcDspGdsCd: item.hcDspGdsCd,
            hcCtgrCd : item.hcCtgrCd,
            id: item.hcGdsCd,
            company: item.brndNm,
            name: item.hcDspGdsNm,
            link: '/pc/product/detail/' + item.hcDspGdsCd,
            rank: item.rcmmGdsRank,
            discount: item.dcRt??'0' +'%',
            price: item.sellPrc,
            originalPrice: item.nrmlSellPrc,
            thumb: cu.getFileFullUrl(item.cpnTnailImgPath),
            alt: item.cpnTnailImgFileNm,
            status: hcSellStCdTmp,
            badge: badgeListTmp.value,
            isHighest: item.highestRealSellPrcYn === 'Y' ? true : false,
            })
        })


        if (key == '2002') {
          manyPopularProList.value = tmpProductList.value
          manyPopularProList.value.sort((a,b) => Number(a.rank ?? 99999) - Number(b.rank ?? 99999)) 

          const totalItems = manyPopularProList.value.length;
          const remainder = totalItems % 8;

          if (remainder !== 0) {
            const dummyCount = 8 - remainder;
            for( let i = 0; i < dummyCount; i++) {
              manyPopularProList.value.push({
                isCashable: false,
                hcBrndCd: "",
                hcDspGdsCd: "",
                hcCtgrCd : "",
                id: "",
                company: "",
                name: "",
                link: "",
                discount: "",
                price: 0,
                originalPrice: 0,
                thumb: "",
                alt: "",
                status: "",
                isHighest: false,
              })
            }
          }
        } else {
          nowPopularProList.value = tmpProductList.value
          nowPopularProList.value.sort((a,b) => Number(a.rank ?? 99999) - Number(b.rank ?? 99999))

          const totalItems = nowPopularProList.value.length;
          const remainder = totalItems % 4;

          if (remainder !== 0) {
            const dummyCount = 4 - remainder;
            for( let i = 0; i < dummyCount; i++) {
              nowPopularProList.value.push({
                isCashable: false,
                hcBrndCd: "",
                hcDspGdsCd: "",
                hcCtgrCd : "",
                id: "",
                company: "",
                name: "",
                link: "",
                discount: "",
                price: 0,
                originalPrice: 0,
                thumb: "",
                alt: "",
                status: "",
                isHighest: false,
              })
            }
          }
        }

        
  swiperNowRef.value?.slideTo(0,0)
  swiperNowRef.value?.update()

  });
}

interface TabData {
  text: string
  hcRcmmGdsClsCd: string
}
const tabList = ref<TabData[]>();
// 탭
const popularCate = ref({
  v3: {
    items: tabList,
    activeIndex: 0
  }
});

onMounted(async () => {
  getDisplayMainInfo();
  getNtcList();
  searchMassCd.value = '1001'
  await getRecommandProductList('1001');
  await getRecommandProductList('2002');
  fetchBuilder.get<AjaxResult<{hc_rcmm_gds_cls_cd : CodeDto[] }>>('/api/v1/common/codes/hc_rcmm_gds_cls_cd')
  .build()
  .execute()
  .then((result) => {

    const tabMapList = result.data.hc_rcmm_gds_cls_cd.map( item => {
      return {
        text   : item.commDtlCdNm,
        hcRcmmGdsClsCd : item.commDtlCd,
      }
    });

    tabMapList.sort((a,b) => Number(a.hcRcmmGdsClsCd) - Number(b.hcRcmmGdsClsCd))

    popularCate.value.v3.items = tabMapList.filter(item => item.hcRcmmGdsClsCd?.startsWith('10'))
  });

});

const currentDepth1 = ref<Depth1 | null>(null);
type Depth1 = {
id: string
name: string
sort: number
to: string
// children: QuickCateData[]
// brands: Brand[]
}

const getDepth = (cate : QuickCateData) =>{
  if(cate.cateCd!=''){
    currentDepth1.value = {
      id: cate.cateCd??'',
      name : cate.cateName,
      to: cate.link,
      sort : 1
    }
    sessionStorage.setItem("product.highCategoryCd", JSON.stringify(currentDepth1.value))

  }
}

// 담긴상품불러오기 팝업
const popupAddedGoodsImportRef = ref<InstanceType<typeof HconAddedGoodsImport> | null>(null)
const showAddedGoodsImportPopup = () => {
  popupAddedGoodsImportRef.value?.handleOpen()
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/pc/display-hcon.scss" as *;
@use "@/assets/scss/pc/import-hcon.scss" as *;
</style>